import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Heading.styles';

const Heading = ({
  title,
  level,
  hasUnderline,
  className,
  isCenter,
  children,
  ...rest
}) => (
    <S.Heading
      hasUnderline={hasUnderline}
      as={`h${level}`}
      className={className}
      isCenter={isCenter}
      {...rest}
    >
      {children || title}
    </S.Heading>
  );

Heading.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  level: PropTypes.string,
  hasUnderline: PropTypes.bool,
  className: PropTypes.string,
  isCenter: PropTypes.bool
};

Heading.defaultProps = {
  children: null,
  title: null,
  level: '1',
  hasUnderline: false,
  className: null,
  isCenter: false
};

export default Heading;
